<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-31 22:31:52
 -->
<template>
  <el-container>
    <el-aside v-if="isShow">
      <SiderMenu />
    </el-aside>
    <el-container :class=" isShow ? 'mars-ape-layout' : 'pdf' ">
      <el-header class="mars-ape-layout-header" v-if="isShow">
        <Header />
      </el-header>
      <el-main :class="isShow ? '': 'pdf-main'">
        <router-view />
      </el-main>
      <el-footer v-if="isShow">
        <Footer />
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
import SiderMenu from './SiderMenu'
import Header from './Header'
import Footer from './Footer'

export default {
  components: {
    SiderMenu,
    Header,
    Footer,
  },
  computed: {
    isShow: {
      get() {
        let isShow = this.$route.meta.isShow == undefined ? true : this.$route.meta.isShow
       return isShow
      }
    }
  }
}
</script>
<style lang="stylus">
.el-container .pdf
  background: rgb(82, 86, 89)
.el-main.pdf-main
  margin: 0
.mod-index
  border-radius 5px
  background #fff
  padding 24px
  min-height 800px
  line-height 1.5
  p
    margin 0
  h3
    margin-block-start 0
    margin-block-end 0.5em
  .xm-gt img
    height 240px
    margin-left -16px
  .jx-zz img
    height 400px
    margin-top 24px
    margin-right 24px
.el-container
  background #f0f2f5
.el-aside
  min-height 100vh
  box-shadow 2px 0 6px rgba(0,21,41,.35)
  position relative
  width auto !important
  z-index 10
  transitionall .3s
  background #2c343f
.el-header
  height 64px !important
  padding 0px
  width 100%
.el-main
  padding 0px
  margin 24px
  overflow inherit
  flexnone !important
  min-height 720px
.main-page-content
  border-radius 5px
  background #ffffff
  padding 24px
.el-footer
  height auto !important
.el-row
    margin-bottom: 20px
    &:last-child
      margin-bottom: 0
  .el-col
    border-radius: 4px
  .bg-purple-dark
    background: #99a9bf
  .bg-purple
    display: flex
    flex-direction row
    justify-content: space-between
    align-items: center
    padding: 20px 30px
    font-size 20px
    background: #F7F8FA
  .info-title, .info-price
    padding: 5px
  .info-title
    color: #333
  .info-img
    width: 55px
    height: 55px
  .bg-purple-light
    background: #e5e9f2
  .grid-content
    border-radius: 4px
    min-height: 36px
  .row-bg
    padding: 10px 0
    background-color: #f9fafc

</style>


